import TiptapItalic from "@tiptap/extension-italic";

import { ActionButton } from "../../components";

export const Italic = TiptapItalic.extend({
	addOptions() {
		return {
			...this.parent?.(),
			button({ editor, t }) {
				return {
					component: ActionButton,
					componentProps: {
						action: () => editor.commands.toggleItalic(),
						isActive: () => editor.isActive("italic") || false,
						shortcutKeys: ["mod", "I"],
						icon: "Italic",
						tooltip: t("editor.italic.tooltip")
					}
				};
			}
		};
	}
});
